export default __webpack_public_path__ + "static/media/tennis-special-featured.bc0e9640.png";